module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAMCAYAAAH317YUAAAAAXNSR0IArs4c6QAAANNJREFUKBVjZGBg4AFiXiCGg/8gFiMQS8KFQByQCAiApSFMBkYMZUCJb1hVQnUwiKIZARb/CBUEmY2Ov4NVIBFMWBSxIsljMC2BIrbooiBHygLxH3QJJD4ziG0NxOhuQuZ7wjRk4lBYBlMAo+ehKVwBk0Cnz0IVXkKXQOdfQxcA+U4OiDcCsSIQ/wViUgEonF8BcQCyRn8g5wcQI4cAITYoiOOQDUFntxBp4AR0jbj4nECJ7TgM3QcUR0nvuAxBF1cBCtwHYpB3HwOxBhBTDASJMQEAnXBMaNjaJmIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Vcar_Collect/select_img.png
// module id = KMrJ
// module chunks = 19